export const getHeaders = (orders) => [
	'No',
	'Kraj',
	'Miesiąc wystawienia',
	'Data sprzedaży',
	'Data wystawienia faktury',
	'Nr Faktury',
	'Korekta Faktury',
	'Nazwa Firmy Klienta na wystawionej fakturze',
	'Nazwa Klienta (osoba fizyczna w specyfikacji excel od pośrednika)',
	`Kwota (netto ${orders[0].currency})`,
	'Kwota VAT',
	`Kwota (brutto ${orders[0].currency})`,
];
